/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_TitleInputs */

const en_privacy_section_2_title = /** @type {(inputs: Privacy_Section_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Data We Collect`)
};

const lv_privacy_section_2_title = /** @type {(inputs: Privacy_Section_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Dati, ko mēs apkopojam`)
};

/**
* | output |
* | --- |
* | "2. Data We Collect" |
*
* @param {Privacy_Section_2_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_title = /** @type {((inputs?: Privacy_Section_2_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_title(inputs)
	return en_privacy_section_2_title(inputs)
});